import * as React from 'react';
import './SingleCouponsItem.less';
import { TransformFont } from '../../../components/transformComp';
import { formatDate } from '../../../utils';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';

interface ISingleCouponsItemPropsType {
    prefixCls?: string;
    onHandleClick?: (data?: any) => void; // 点击领取事件
    data?: any;
}

/**
 * 优惠券领取单列
 * @class SingleCouponsItem
 * @extends {React.Component<ISingleCouponsItemPropsType, any>}
 */
@observer
class SingleCouponsItem extends React.Component<ISingleCouponsItemPropsType, any> {
    static defaultProps = {
        prefixCls: 'single-coupons'
    };

    // 领取状态 1：可领取 2：已领取 3：已抢光
    @autobind
    private _showStatus(status: any): React.ReactNode {
        const {prefixCls, onHandleClick} = this.props;
        if (status === 1) {
            return (
                <span className={`${prefixCls}-btn`} onClick={() => {
                    onHandleClick && onHandleClick();
                }}>
                    点击领取
                </span>
            );
        } else if (status === 2) {
            return (
                <div className={`${prefixCls}-statusBg-1`} />
            );
        } else {
            return (
                <div className={`${prefixCls}-statusBg-2`} />
            );
        }
    }

    private _showTime(data: any): any {
        if (data.validateType === 1) {
            return `领取当天有效`
        } else if (data.validateType === 2) {
            return `领取后有效期${data.validateDay}天`
        } else {
            return (
                <div>
                    {formatDate(data.startTime, 'yyyy.MM.dd hh:mm')}
                    至
                    {formatDate(data.endTime, 'yyyy.MM.dd hh:mm')}
                </div>
            )
        }
    }

    render(): React.ReactNode {
        const {prefixCls, data, onHandleClick} = this.props; // color
        return (
            <div className={`${prefixCls} ` + (data.receivedStatus === 3 ? `${prefixCls}-noUse` : ``)}>
                <div className={`${prefixCls}-left`} onClick={() => {
                    onHandleClick && data.receivedStatus === 1 && onHandleClick();
                }}>
                    <div className={`${prefixCls}-context`}>
                        <span className={`${prefixCls}-rmb`}>￥</span>
                        <TransformFont
                            font={data.couponMoney}
                            firstSize={'3.6rem'}
                            secondsSize={'1.4rem'}
                            class={`${prefixCls}-itemPrice-font`}
                        />
                        <div className={`${prefixCls}-msg`}>
                            <p>满￥{data.useLimit}可用</p>
                            <p>{data.couponName}</p>
                        </div>
                    </div>
                    <div className={`${prefixCls}-time`}>
                        {this._showTime(data)}
                    </div>
                </div>
                <div className={`${prefixCls}-right`}>
                    {this._showStatus(data.receivedStatus)}
                </div>
            </div>
        );
    }
}

export default SingleCouponsItem;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/couponsItem/singleCouponsItem/SingleCouponsItem.tsx